import {Menu, MenuGroup, Sidebar} from 'react-admin-base-nazox';
import {useUser} from './Components/UserProvider';

export default function MenuSidebar() {
    const user = useUser();

    return <Sidebar>
        <MenuGroup title="Home">
            {user.type === 512 && <Menu title="Home Site" to="https://wisefull.org/" icon="fas fa-home"/>}
        </MenuGroup>

        {user.type === 512 && <MenuGroup title="Frontend">
            <Menu title="Languages" to="/language" icon="fas fa-language"/>
            <Menu title="Categories" to="/category" icon="fas fa-file-alt"/>
            <Menu title="Blog" to="/post" icon="fas fa-rss-square"/>
            <Menu title="Pages" to="/page" icon="fas fa-file-alt"/>
            <Menu title="Announcements" to="/announcement" icon="fas fa-bullhorn"/>
            <Menu title="Banners" to="/banner-group" icon="fas fa-images"/>
            <Menu title="Comments" to="/comment" icon="fas fa-comment"/>
            <Menu title="Seo Redirect" to="/seo-redirect" icon="fas fa-random"/>
            <Menu title="Our Team" to="/team-member" icon="fas fa-random"/>
        </MenuGroup>}
        
        {user.type === 512 && <MenuGroup title="LMS">
            <Menu title="Courses" to="/course" icon="fas fa-file-alt"/>
            <Menu title="Users" to="/user" icon="fas fa-file-alt"/>
        </MenuGroup>}
        
        <MenuGroup title="My Data">
            <Menu title="Messages" to="/message" icon="fas fa-user"/>
            <Menu title="My Profile" to="/profile" icon="fas fa-user"/>
        </MenuGroup>
    </Sidebar>;
}
